module.exports = __webpack_public_path__ + "static/media/longest-drive.d8398fef.png";